// components/product/ProductSkeleton.jsx
import React from 'react';
import { FiImage } from 'react-icons/fi';

const ProductSkeleton = ({ isDarkMode }) => {
  return (
    <div className={`grid grid-cols-1 gap-6 lg:grid-cols-2 p-6 rounded-2xl ${
      isDarkMode ? 'bg-gray-800' : 'bg-white'
    }`}>
      {/* Image Skeleton */}
      <div className={`overflow-hidden rounded-xl ${
        isDarkMode ? 'bg-gray-700' : 'bg-gray-100'
      } animate-pulse`}>
        <div className="flex items-center justify-center p-8 rounded-xl">
          <FiImage size={48} className={isDarkMode ? 'text-gray-600' : 'text-gray-300'} />
        </div>
      </div>

      {/* Details Skeleton */}
      <div className="flex flex-col space-y-4">
        {/* Title Skeleton */}
        <div className="space-y-2">
          <div className={`h-6 w-48 rounded ${
            isDarkMode ? 'bg-gray-700' : 'bg-gray-200'
          } animate-pulse`}></div>
          <div className={`h-4 w-64 rounded ${
            isDarkMode ? 'bg-gray-700' : 'bg-gray-200'
          } animate-pulse`}></div>
        </div>

        {/* Price Card Skeleton */}
        <div className={`p-5 rounded-xl ${
          isDarkMode ? 'bg-gray-700' : 'bg-gray-100'
        } animate-pulse`}>
          <div className="flex flex-col items-center justify-between md:flex-row">
            <div className={`h-4 w-20 rounded ${
              isDarkMode ? 'bg-gray-600' : 'bg-gray-200'
            }`}></div>
            <div className={`h-8 w-32 rounded mt-2 md:mt-0 ${
              isDarkMode ? 'bg-gray-600' : 'bg-gray-200'
            }`}></div>
          </div>
        </div>

        {/* Variants Section Skeleton */}
        <div className={`p-4 rounded-xl ${
          isDarkMode ? 'bg-gray-700' : 'bg-gray-100'
        } animate-pulse`}>
          <div className="flex items-center justify-center mb-3">
            <div className={`h-4 w-24 rounded ${
              isDarkMode ? 'bg-gray-600' : 'bg-gray-200'
            }`}></div>
          </div>
          <div className="grid grid-cols-1 gap-2 sm:grid-cols-2">
            {[1, 2, 3, 4].map((i) => (
              <div key={i} className={`p-3 rounded-xl ${
                isDarkMode ? 'bg-gray-800' : 'bg-white'
              }`}>
                <div className="flex items-start gap-2">
                  <div className={`w-4 h-4 rounded-full ${
                    isDarkMode ? 'bg-gray-600' : 'bg-gray-200'
                  }`}></div>
                  <div className="flex-1">
                    <div className={`h-3 w-16 rounded ${
                      isDarkMode ? 'bg-gray-600' : 'bg-gray-200'
                    }`}></div>
                    <div className={`h-2 w-12 rounded mt-1 ${
                      isDarkMode ? 'bg-gray-600' : 'bg-gray-200'
                    }`}></div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Button Skeleton */}
        <div className={`h-12 rounded-xl ${
          isDarkMode ? 'bg-gray-700' : 'bg-gray-200'
        } animate-pulse w-full mt-2`}></div>

        {/* Features Skeleton */}
        <div className="grid grid-cols-3 gap-3 mt-2">
          {[1, 2, 3].map((i) => (
            <div key={i} className={`p-2 rounded-lg ${
              isDarkMode ? 'bg-gray-700' : 'bg-gray-100'
            } animate-pulse`}>
              <div className="flex flex-col items-center">
                <div className={`w-6 h-6 rounded-full mb-1 ${
                  isDarkMode ? 'bg-gray-600' : 'bg-gray-200'
                }`}></div>
                <div className={`h-2 w-12 rounded ${
                  isDarkMode ? 'bg-gray-600' : 'bg-gray-200'
                }`}></div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ProductSkeleton;